import { DistributionType } from '@aviv-search/types';
/**
 * Used to fix non compliant models coming from the SEO Url Resolver Api.
 * -> Search Model with no distribution and/or estate types need a default fallback
 * -> No distribution type fallbacks on BUY & RENT
 * -> No estate type fallbacks to House & Apartment - done at transformer level
 */
export const applySearchModelFallback = (model) => {
    const { distributionTypes = [], estateTypes = [], ...rest } = model;
    const distributionForSerp = distributionTypes.length > 0 ? distributionTypes : [DistributionType.BUY, DistributionType.RENT];
    return {
        ...rest,
        distributionTypes: distributionForSerp,
        estateTypes,
    };
};
